import React, { useContext } from "react";
import { Navigation, Pagination, Thumbs, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRouter } from "next/router";
import OurPeopleCard from "../common/OurPeopleCard";
import { useState } from "react";
import { isMobileContext } from "../../contexts/isMobileContext";
import FadeIn from "../Animations/FadeIn";
import Magnitizer from "../Animations/Magnitizer";

export default function OurPeople({ ourPeople }) {
	const { locale } = useRouter();
	const { isMobile } = useContext(isMobileContext)
	const [activeSlide, setActiveSlide] = useState("0" + 1);
	return (
		<div className="our-people-section" id="our-people">
			<div className="header">
				<h2 className="title">{ourPeople?.header}</h2>
			</div>
			<Swiper
				style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
				modules={[Navigation, Pagination, Mousewheel]}

				navigation={{
					nextEl: ".swiper-button-next-our-people",
					prevEl: ".swiper-button-prev-our-people",
				}}
				pagination={{
					type: "progressbar",
					el: ".swiper-our-people-navigation",
				}}
				className="swiper-our-people-section"
				slidesPerView={1.2}
				spaceBetween={20}
				breakpoints={{
					768: {
						slidesPerView: 1.75,
						spaceBetween: 40,
					},
					1024: {
						slidesPerView: 3.5,
						spaceBetween: 50,
					},
				}}
				onSlideChange={(swiper) =>
					setActiveSlide(
						swiper.activeIndex < 9
							? "0" + (swiper.activeIndex + 1)
							: swiper.activeIndex + 1
					)
				}
			>
				{ourPeople?.peoples.map((item, index) => (
					<SwiperSlide key={index}>
						<OurPeopleCard
							item={item}
						/>
					</SwiperSlide>
				))}
			</Swiper>
			<div className={`swiper-navigation-container
			${isMobile && ourPeople?.peoples.length <= 1 && "d-none"}
			${!isMobile && ourPeople?.peoples.length <= 3 && "d-none"}
			`}>
				<div className="navigation-container">
					<div className="slide-number-container bold">
						<div>{activeSlide}</div>
						<div>{"0" + ourPeople?.peoples.length}</div>
					</div>
					<div className="swiper-our-people-navigation swiper-pagination-progressbar"></div>
				</div>
				<div className="arrows-container">
					<Magnitizer dataDest={1.5}>
						<div className="swiper-button-prev swiper-button-prev-our-people our-people-arrow"></div>
					</Magnitizer>
					<Magnitizer dataDest={1.5}>
						<div className="swiper-button-next swiper-button-next-our-people  our-people-arrow"></div>
					</Magnitizer>
				</div>
			</div>
		</div>
	);
}
